export const DEFAULT_FEEDBACK_PRETTY_NAME = 'Karls Technology';
export const DEFAULT_FEEDBACK_INTERNAL_NAME = 'Karls Technology';
export const DEFAULT_FEEDBACK_LINK = 'https://g.page/r/Ca9Y1qbCIdZ6EAE/review';
